import { scrollToAnchor } from '../utils/_scroll'
import { debounce } from "../utils/_debounce";

export default class LocalMenu {
  ready () {
    this.NAVBAR = document.querySelector('.single-car-nav')
    if (this.NAVBAR) {
      this.handleSubMenus()
      this.initMenuItems()
      this.initStickyNav()
      this.tabToSectionOnLoad()

      window.addEventListener('resize', debounce(() => this.handleSubMenus(), 100))
    }
  }

  handleSubMenus () {
    const INNER = document.querySelector('.single-car-nav__inner')
    const SUB_MENUS = document.querySelectorAll('.single-car-nav__sub-links')
    if (! INNER || SUB_MENUS.length <= 0) {
      return
    }

    const INNER_RIGHT = INNER.getBoundingClientRect().right

    for (let i = 0; i < SUB_MENUS.length; i++) {
      const SUB_MENU = SUB_MENUS[i]
      const PARENT_LINK = SUB_MENU.parentElement.querySelector('.single-car-nav__link')

      jQuery(SUB_MENU).removeAttr('style')

      const SUB_MENU_WIDTH = SUB_MENU.getBoundingClientRect().width
      const PARENT_LINK_WIDTH = PARENT_LINK.getBoundingClientRect().width
      const PARENT_LINK_RIGHT = PARENT_LINK.getBoundingClientRect().right

      const CURRENT_RIGHT = (PARENT_LINK_RIGHT - PARENT_LINK_WIDTH / 2) + (SUB_MENU_WIDTH / 2)

      if (CURRENT_RIGHT <= INNER_RIGHT) {
        return
      }


      // console.log('INNER', INNER_WIDTH, INNER_RIGHT)
      // console.log('PARENT', PARENT_LINK_WIDTH, PARENT_LINK_RIGHT)
      // console.log('SUB_MENU', SUB_MENU_WIDTH, SUB_MENU_RIGHT)
      //
      // console.log('?A?', (PARENT_LINK_RIGHT - PARENT_LINK_WIDTH / 2) + (SUB_MENU_WIDTH / 2), INNER_RIGHT)

      jQuery(SUB_MENU)
        .css('left', `calc(-${CURRENT_RIGHT - INNER_RIGHT}px + 50%)`)
        .css('--custom-left', `calc(50% + ${CURRENT_RIGHT - INNER_RIGHT}px)`)
    }
  }

  tabToSectionOnLoad() {
    const currentUrlId = window.location.hash
    const currentLink = document.querySelector(`[href="${currentUrlId}"]`)
    const links = document.querySelectorAll('.single-car-nav__link')
    const selectElement = document.querySelector('.single-car-nav__link-select')

    if ((currentUrlId.length > 0) && currentLink && (links.length > 0) ) {
      this.tabToSection(currentUrlId, currentLink, links)
    }

    if (selectElement && (currentUrlId.length > 0)){
      selectElement.value = currentUrlId
    }
  }

  initStickyNav () {
    this.NAVBAR_WRAP = this.NAVBAR.querySelector('.single-car-nav__wrap')
    this.MAIN_HEADER = document.getElementById('main_header')
    this.navbar_is_sticky = false

    if (this.NAVBAR_WRAP && this.MAIN_HEADER) {
      this.scrollEvent()
      window.addEventListener('scroll', () => this.scrollEvent())
    }
  }

  scrollEvent () {
    /**
     * sticky navbar
     */
    const navbarY = this.NAVBAR.getBoundingClientRect().top
    const navbarOffset = this.getAdminbarHeight()
    if (navbarY <= navbarOffset) {
      if (!this.navbar_is_sticky) {
        this.NAVBAR_WRAP.style.top = navbarOffset + 'px'
        this.NAVBAR_WRAP.style.position = 'fixed'
        this.navbar_is_sticky = true
      }
    } else {
      if (this.navbar_is_sticky) {
        this.NAVBAR_WRAP.style.top = ''
        this.NAVBAR_WRAP.style.position = ''
        this.navbar_is_sticky = false
      }
    }

    /**
     * sticky header
     */
    const headerOffset = this.getNavigationHeight() + this.getAdminbarHeight()
    const currentOffset = this.NAVBAR.getBoundingClientRect().top - this.getNavigationHeight()
    if (navbarY <= headerOffset) {
      this.MAIN_HEADER.style.top = currentOffset + 'px'
      this.MAIN_HEADER.style.position = 'fixed'
    } else {
      this.MAIN_HEADER.style.top = ''
      this.MAIN_HEADER.style.position = ''
    }

    /**
     * active scroll item
     */
    const LINKS = document.querySelectorAll('.single-car-nav__link')
    if (LINKS.length > 0) {
      for (let i = 0; i < LINKS.length; i++) {
        const LINK = LINKS[i]
        const URL = LINK.getAttribute('href')
        const EL = document.getElementById(URL.replace('#', ''))
        const OFFSET = (this.getNavbarHeight() + this.getAdminbarHeight()) + 1
        if (EL) {
          if (URL.indexOf('wg') !== -1) return
          if (this.isElementInViewport(EL, OFFSET, OFFSET)) {
            LINK.classList.add('active')
          } else {
            LINK.classList.remove('active')
          }
        }
      }
    }
  }

  initMenuItems () {
    // Scroll to id when link is clicked
    const LINKS = document.querySelectorAll('.single-car-nav__link')
    if (LINKS.length > 0) {
      for (let i = 0; i < LINKS.length; i++) {
        const LINK = LINKS[i]
        LINK.addEventListener('click', (e) => {
          e.preventDefault()

          if (LINK.dataset.hasSubLinks !== undefined) {
            return
          }

          const URL = LINK.getAttribute('href')

          // go to link
          if (URL.indexOf('http') !== -1) {
            window.location.href = URL
          }

          this.tabToSection(URL, LINK, LINKS)

          // scroll to section
          if (this.elementExists(URL) && URL.indexOf('wg') === -1) {
            const OFFSET = this.getNavbarHeight() + this.getAdminbarHeight()
            scrollToAnchor(URL, OFFSET)
          }
        })
      }
    }

    // Scroll to top when menu logo is clicked
    const MENU_LOGO = document.querySelector('.single-car-nav__logo-container')
    if (MENU_LOGO) {
      MENU_LOGO.addEventListener('click', (e) => {
        e.preventDefault()
        const URL = MENU_LOGO.getAttribute('href')
        if (this.elementExists(URL)) {
          const OFFSET = this.getNavbarHeight() + this.getAdminbarHeight()
          scrollToAnchor(URL, OFFSET)
        }
      })
    }

    // Scroll when select option change
    const SELECT = document.querySelector('.single-car-nav__link-select')
    if (SELECT) {
      SELECT.addEventListener('change', () => {
        const URL = SELECT.options[SELECT.selectedIndex].value

        // go to link
        if (URL.indexOf('http') !== -1) {
          window.location.href = URL
        }

        this.tabToSection(URL)
        if (this.elementExists(URL)) {
          const OFFSET = this.getNavbarHeight() + this.getAdminbarHeight()
          if (URL.indexOf('wg') === -1) {
            scrollToAnchor(URL, OFFSET)
          }
        }
      })
    }
  }

  // tab to section
  tabToSection (URL, LINK = '', LINKS = []) {
    if (URL.indexOf('wg') !== -1) {
      const WGS = document.querySelectorAll('.mtt-widget-group')
      const HASH = URL.replace('#', '')
      const OFFSET = (window.pageYOffset || document.documentElement.scrollTop)
      if (WGS.length > 0) {
        for (let i = 0; i < WGS.length; i++) {
          const WG = WGS[i]
          if (WG.getAttribute('id') === HASH) {
            WG.classList.remove('mtt-widget-group--hide')
          } else {
            WG.classList.add('mtt-widget-group--hide')
          }
        }
        window.scroll(0, OFFSET)
      }
      if (LINK && LINKS.length > 0) {
        for (let i = 0; i < LINKS.length; i++) {
          LINKS[i].classList.remove('active')
        }
        LINK.classList.add('active')
        jQuery(LINK).closest('.single-car-nav__link-wrapper').find('a.single-car-nav__link[data-has-sub-links]').addClass('active')
      }
    }
  }

  /**
     * Check if element exists
     * @param {string} id
     */
  elementExists (id) {
    return !!document.getElementById(id.replace('#', ''))
  }

  /**
     * Get height of main navigation
     */
  getNavigationHeight () {
    return this.getScreenWidth() > 580 ? 80 : 64
  }

  /**
     * Get height of main navigation
     */
  getNavbarHeight () {
    return this.getScreenWidth() > 1280 ? 88 : 64
  }

  /**
     * Get height of adminbar if it exists
     */
  getAdminbarHeight () {
    const ADMIN_BAR = document.getElementById('wpadminbar')
    return ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0
  }

  /**
     * Get screen width
     */
  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }

  getScreenHeight () {
    return window.innerHeight || document.documentElement.clientHeight
  }

  isElementInViewport (el, top = 0, bottom = 0) {
    const rect = el.getBoundingClientRect()
    return rect.top <= top && rect.bottom > bottom
  }
}
